import React, { useEffect, useState } from 'react';
import Wrapper from 'components/Wrapper';
import LoaderScreen from 'components/LoaderScreen';
import VizScreen from 'components/VizScreen';

const Index = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {

    setTimeout(() => setIsLoading(false), 3000);


  }, [isLoading, setIsLoading]);


  return(
    <Wrapper>
      <VizScreen />
    </Wrapper>
  )
}

export default Index;